/* istanbul ignore file */
/* tslint:disable */
 
import type { Nested } from '../models/Nested';
import type { PermissionDetails } from '../models/PermissionDetails';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AccessService {

  /**
   * @param teamId 
   * @returns Nested 
   * @throws ApiError
   */
  public static accessAccessTeamList(
teamId: string,
): CancelablePromise<Array<Nested>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/access/access-team/{team_id}/',
      path: {
        'team_id': teamId,
      },
    });
  }

  /**
   * @param teamId 
   * @param requestBody 
   * @returns any No response body
   * @throws ApiError
   */
  public static accessAccessTeamCreate(
teamId: string,
requestBody: Array<Nested>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/access/access-team/{team_id}/',
      path: {
        'team_id': teamId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param userId 
   * @returns Nested 
   * @throws ApiError
   */
  public static accessAccessUserList(
userId: string,
): CancelablePromise<Array<Nested>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/access/access-user/{user_id}/',
      path: {
        'user_id': userId,
      },
    });
  }

  /**
   * @param userId 
   * @param requestBody 
   * @returns any No response body
   * @throws ApiError
   */
  public static accessAccessUserCreate(
userId: string,
requestBody: Array<PermissionDetails>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/access/access-user/{user_id}/',
      path: {
        'user_id': userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param contentType 
   * @returns Nested 
   * @throws ApiError
   */
  public static accessForUserList(
contentType?: string,
): CancelablePromise<Array<Array<Nested>>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/access/for-user/',
      query: {
        'content_type': contentType,
      },
    });
  }

}
